import { render } from "./HeroApprovalOfficialBusinessModal.vue?vue&type=template&id=5b5dd883&scoped=true"
import script from "./HeroApprovalOfficialBusinessModal.vue?vue&type=script&lang=js"
export * from "./HeroApprovalOfficialBusinessModal.vue?vue&type=script&lang=js"

import "./HeroApprovalOfficialBusinessModal.vue?vue&type=style&index=0&id=5b5dd883&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5dd883"]])

export default __exports__